/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {
  devicesAreTotalRowsSelectedSelector,
  devicesFiltersSelector,
  devicesGridSearchSelector,
  devicesIncludeSubAccountsSelector,
  devicesSearchSelector,
  devicesSelectedSelector,
  devicesTotalRowsCountSelector
} from '../pages/devices/state-selectors';

/**
 * React Hook to provide local selector/state for device grid selection functionality.
 * 
 *  ```typescript
 *   import {useGridDeviceSelection} from '@ion/applications/src/bulk';
 * 
 *   const {
 *     selectedDevices,
 *     areTotalRowsSelected,
 *     totalRowsCount,
 *     filters,
 *     search,
 *     includeSubAccounts,
 *   } = useGridDeviceSelection();
 *  ```
 */
export const useGridDeviceSelection = () => {
  const selectedDevices      = useSelector(devicesSelectedSelector);
  const areTotalRowsSelected = useSelector(devicesAreTotalRowsSelectedSelector);
  const totalRowsCount       = useSelector(devicesTotalRowsCountSelector);
  const search               = useSelector(devicesSearchSelector);
  const gridSearch           = useSelector(devicesGridSearchSelector);
  const filters              = useSelector(devicesFiltersSelector);
  const includeSubAccounts   = useSelector(devicesIncludeSubAccountsSelector);

  return {
    selectedDevices,
    areTotalRowsSelected,
    totalRowsCount,
    filters,
    search,
    gridSearch,
    includeSubAccounts
  };
};

export default useGridDeviceSelection;
